/**
 * トップ sec06：SP（max-width:768px）のみ .img02 内画像を自動フェード切替。
 * PC は _top.scss の :has(ホバー／フォーカス) に任せ、本スクリプトはクラスを付けない。
 */
(function () {
  var inner = document.querySelector(".sec06-inner");
  if (!inner) return;

  var spMq = window.matchMedia("(max-width: 768px)");
  var reduceMq = window.matchMedia("(prefers-reduced-motion: reduce)");
  var prefix = "is-sec06-img--";
  var ids = ["01", "02", "03", "04", "05"];
  var intervalMs = 5000;

  var timerId = null;
  var idx = 0;
  var sectionVisible = false;

  function removeStateClasses() {
    ids.forEach(function (id) {
      inner.classList.remove(prefix + id);
    });
  }

  function applyIndex(i) {
    idx = ((i % ids.length) + ids.length) % ids.length;
    removeStateClasses();
    inner.classList.add(prefix + ids[idx]);
  }

  function clearTimer() {
    if (timerId !== null) {
      clearInterval(timerId);
      timerId = null;
    }
  }

  function maybeStartTimer() {
    clearTimer();
    if (!spMq.matches || reduceMq.matches || !sectionVisible) return;
    timerId = window.setInterval(function () {
      applyIndex(idx + 1);
    }, intervalMs);
  }

  function refreshVisibleFromRect() {
    var rect = inner.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    sectionVisible = rect.top < vh && rect.bottom > 0;
  }

  function onSpOrReduceChange() {
    clearTimer();
    if (!spMq.matches) {
      removeStateClasses();
      sectionVisible = false;
      return;
    }
    applyIndex(0);
    refreshVisibleFromRect();
    maybeStartTimer();
  }

  var io = new IntersectionObserver(
    function (entries) {
      var e = entries[0];
      sectionVisible = e.isIntersecting;
      maybeStartTimer();
    },
    { threshold: 0.15, rootMargin: "0px 0px -10% 0px" }
  );
  io.observe(inner);

  if (spMq.addEventListener) {
    spMq.addEventListener("change", onSpOrReduceChange);
    reduceMq.addEventListener("change", onSpOrReduceChange);
  } else {
    spMq.addListener(onSpOrReduceChange);
    reduceMq.addListener(onSpOrReduceChange);
  }

  if (spMq.matches) {
    applyIndex(0);
    refreshVisibleFromRect();
    maybeStartTimer();
  }
})();
